export function isHostInstanceId(value: unknown): value is string {
  return typeof value === 'string' && value.length > 0 && value.length <= 256 && !/[^A-Za-z0-9._:-]/.test(value)
}

export function readHostInstanceEvidence(meta: unknown): string | undefined {
  if (!meta || typeof meta !== 'object') return
  const value = (meta as Record<string, unknown>)['copilot.hostInstance']
  if (!value || typeof value !== 'object') return
  const evidence = value as Record<string, unknown>
  if (evidence.version === 1 && isHostInstanceId(evidence.id)) return evidence.id
}
